import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

export const enhancePrompt = (payload) =>
  http.post("/prompts/enhance", payload).then((r) => r.data);

export const generateMovie = (payload) =>
  http.post("/movies/generate", payload).then((r) => r.data);

export const listMovies = () => http.get("/movies").then((r) => r.data);
export const getMovie = (id) => http.get(`/movies/${id}`).then((r) => r.data);
export const deleteMovie = (id) => http.delete(`/movies/${id}`).then((r) => r.data);
export const updateNarration = (id, payload) =>
  http.put(`/movies/${id}/narration`, payload).then((r) => r.data);
export const updatePrompt = (id, payload) =>
  http.put(`/movies/${id}/prompt`, payload).then((r) => r.data);
export const updateScene = (id, index, payload) =>
  http.put(`/movies/${id}/scenes/${index}`, payload).then((r) => r.data);
export const rerollScene = (id, index) =>
  http.post(`/movies/${id}/scenes/${index}/reroll`).then((r) => r.data);

export const videoUrl = (id) => `${API}/movies/${id}/video`;
export const audioUrl = (id) => `${API}/movies/${id}/audio`;
export const posterUrl = (id) => `${API}/movies/${id}/poster.jpg`;
export const shareUrl = (id) => `${API}/share/${id}`;
